import React from "react";

import { Link } from "react-router-dom";

import { Tag } from "antd";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";
import { AmountText } from "../../../../../core/components/widget/amountInline";

import { configureField } from "../../../../../core/utils/list";

const confirmationMessage = "Are you sure?";

export const basicColumns = (props) => {
    const { loading, filters, resize, hidden } = props;

    if (loading) {
        return [];
    }
    return [
        {
            title: "Job",
            dataIndex: "id",
            width: 100,
            ...configureField("j.id", filters, resize, hidden, true, false, false, 150),
            render: (id) => <>J-{id}</>,
        },
        {
            title: "Job E-ID",
            dataIndex: "eid",
            width: 200,
            ...configureField("j.eid", filters, resize, hidden, true, false, true, 200),
        },
        {
            title: "Name",
            dataIndex: "name",
            ellipsis: true,
            ...configureField("j.name", filters, resize, hidden, true, false, true, 500),
        },
        {
            title: "Finance Date",
            dataIndex: "financeDate",
            width: 150,
            ...configureField("j.financeDate", filters, resize, hidden, true, false, true, 200),
            render: (financeDate) => {
                if (financeDate) return <>{Moment(financeDate).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Receivable Code",
            dataIndex: "code",
            width: 150,
            ...configureField("j.code", filters, resize, hidden, true, false, true, 200),
        },
        {
            title: "Amount",
            dataIndex: "totalToReceiveValue",
            width: 150,
            ...configureField("j.totalToReceiveValue", filters, resize, hidden, true, false, true, 200),
            render: (amountValue, record) => {
                return (
                    <AmountText
                        value={Math.round((amountValue - record.balanceClient) * 10000) / 10000}
                        type={record.totalToReceiveType}
                    />
                );
            },
        },
        {
            title: "Completed At",
            dataIndex: "completedAt",
            key: "completedAt",
            doctrineKey: "j.completedAt",
            sorter: true,
            render: (date) => {
                if (date) return <>{Moment(date).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text) => <Tag color="green">{text}</Tag>,
            filters: [
                { text: "New", value: "New" },
                { text: "In Progress", value: "In Progress" },
                { text: "Completed", value: "Completed" },
            ],
        },
    ];
};
